
import useSWR from "swr";
import CardSoundGroup from "./CardSoundGroup";
import sortingShuffle from "../../../scripts/shuffle";
import { useEffect, useRef, useContext } from "react";
import CardSoundGroupPosition from "./CardSoundGroupPosition";
import CardOtherContrastsGroup from "./CardOtherContrastsGroup";

const fetcher = (...args) => fetch(...args).then((res) => res.json());

const Cards = ({L2Lang, L1L2List, AllSounds, units, unit, exerciseHandler, focusId}) => {
    const category = unit.split('_')[0]
   

    const itemsRef = useRef(null);
    /* scroll to category from the left menu*/
    useEffect(()=>{ if (focusId) {scrollToId(focusId);}},[focusId])
    function scrollToId(itemId) {

        const frames = [ 
            { transform: "translateX(2em)"},
            { transform: "translateX(-2em)"},
            { transform: "translateX(0)"},
      
        ]    
        const map = getMap();
        const node = map.get(itemId);
        if (node) {
        node.scrollIntoView({
            behavior: 'auto',
            block: 'nearest',
            inline: 'start'
        });
        node.animate(  
            frames ,{ duration: 2000 , fill: "forwards", iterations: 1 } 
              );
            }
        
        }
  
    function getMap() {
      if (!itemsRef.current) {
        // Initialize the Map on first usage.
        itemsRef.current = new Map();
      }
      return itemsRef.current;
    }
  

   
    

  
    const path = 'soundsperunit'
    

    const { data, error } = useSWR(
        
            `${process.env.REACT_APP_API_URL}/${path}/${L2Lang}/${units}/${unit}/all`,
            fetcher,  {
                revalidateIfStale: false,
                revalidateOnFocus: false,
                revalidateOnReconnect: false
                }
            );
    
    
    if (error) return (
        <div className="flex justify-center shadow-lg mx-auto  2xl:py-48 mx-auto p-6 2xl:px-12">
            <p>Data servers are not availableat the moment</p>
        </div>

      

    )
    if (!data) return ( 
        <div className="flex justify-center shadow-lg mx-auto  2xl:py-48 mx-auto p-6 2xl:px-12">
            <div  role="status">
                <svg aria-hidden="true" className="w-32 h-32 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                </svg>
            <span className="sr-only">Loading...</span>
            </div>
         </div>
        
    )

    return(
        <div className="mx-auto flex w-full max-w-4xl flex-col gap-16 rounded-3xl border border-slate-200 bg-white pb-10 shadow-[0_18px_50px_rgba(16,42,67,0.08)] 2xl:gap-0 2xl:pb-0">
        <p className="px-6 pt-10 text-center font-serif text-2xl font-bold tracking-tight text-cyan-900 md:text-4xl"> {category}</p>
        {/* {console.log('JOY: front page, level 1,  category block :', unit)} */}
                        
          
            
                {data.soundgroups && data.soundgroups.map(
                
                    (el,i)=>{
                        const key_value =unit+'_'+el.Group_name
                      
                        var products = [];
                        
                        const keys = Object.keys(el.dictionary);
                        
                        keys.forEach((key, index) => {
                            products.push(el.dictionary[key])
                        });
                        
                            
                        let AudioSample = [];
                        let Sample = [];
                        const shuffledProducts = sortingShuffle(products)[0];
                        // Skip soundgroups with no exercises to sample from.
                        if (!shuffledProducts || !shuffledProducts[0]) {
                            return null;
                        }
                        Sample = shuffledProducts[0]
                        
                        let choice = [];
                        AudioSample = Sample.MP_wordpair;
                        
                        // Skip exercises without a full minimal-pair audio sample (e.g. non-discr sheets)
                        if (!AudioSample || AudioSample.length < 2) {
                            return null;
                        }
                       
                        let audio_tag = ''
                        
                        if (L2Lang === 'Norwegian') {
                            audio_tag ='audio_'+AudioSample[0].dialect 
                          
                        }
                        if (L2Lang === 'English') {
                            audio_tag ='audio'
                           
                        }

                        if (L2Lang === 'Norwegian' || L2Lang === 'English') {
                         choice = [  `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(AudioSample[0].audio_xpm)[0],
                                     `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(AudioSample[1].audio_xpm)[0]
                                 ]
                        }
                        else 
                        {   
                           
                            if (AudioSample) { 
                            let choices =[  [ `${process.env.REACT_APP_STATIC_URL}`+sortingShuffle(AudioSample[0].audio_xpm).slice(0,1), 
                            `${process.env.REACT_APP_STATIC_URL}`+sortingShuffle(AudioSample[1].audio_cpm).slice(0,1)
                            ],
                            [ `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(AudioSample[0].audio_cpm).slice(0,1),
                            `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(AudioSample[1].audio_xpm).slice(0,1) 
                            ]
                            ]
                          
              
                            choice = sortingShuffle(choices)[0]
                            
                            }
                        }
                        return (    

                            
                                    (L2Lang === 'Norwegian' ||  L2Lang === 'English') ?
                                        <div    key={key_value}  
                                                className="flex justify-center py-6"
                                                ref={(node) => {
                                                    const map = getMap();
                                                    if (node) {
                                                      map.set(key_value, node);
                                                    } else {
                                                      map.delete(key_value);
                                                    }
                                                  }}        
                                        
                                        
                                        >  
                                        
                                            <CardSoundGroupPosition 
                                                include = {L1L2List.length !== 0 ? 
                                                                L1L2List.includes(el.sound) ? true :    AllSounds.includes(el.sound) ? false :  true 
                                                            :
                                                            true
                                                            }  
                                                exercise = {el} 
                                                l2={L2Lang}
                                                choice={{'choice' : choice, 'Sample_name' : Sample.Exercise_name}}
                                                exHandler={(state) =>
                                                    {
                                                        exerciseHandler(state);
                                                        
                                                    }
                                                }
                                                
                                            />   
                                        </div>


                                    :   
                                    
                                        
                                        
                                        <div    key={key_value}  
                                                className="flex justify-center"
                                                ref={(node) => {
                                                    const map = getMap();
                                                    if (node) {
                                                      map.set(key_value, node);
                                                    } else {
                                                      map.delete(key_value);
                                                    }
                                                  }}
                                        >  

                                            {el.sound ? <CardSoundGroup
                                                
                                            include = {L1L2List.length !== 0 ? 
                                                                el.sound.split('/').length > 1 ?
                                                                (L1L2List.includes(el.sound.split('/')[0]) || L1L2List.includes(el.sound.split('/')[1])) ? true : (AllSounds.includes(el.sound.split('/')[0]) && AllSounds.includes(el.sound.split('/')[1])) ? false : true
                                                                : 
                                                                L1L2List.includes(el.sound) ? true :    AllSounds.includes(el.sound) ? false :  true 
                                                            :
                                                            true
                                                            }  
                                                exercise = {el} 
                                                choice={{'choice' : choice, 'Sample_name' : Sample.Exercise_name}}
                                                exHandler={(state) =>
                                                    {
                                                        exerciseHandler(state);
                                                        
                                                    }
                                                }
                                                
                                            />
                                                :
                                                <CardOtherContrastsGroup
                                                exercise = {el} 
                                                
                                                exHandler={(state) =>
                                                    {
                                                        exerciseHandler(state);
                                                        
                                                    }
                                                }

                                                />
                                        
                                            }   
                                        </div>

                                        
                                                    
                        )
                    }
                )}
            </div>


            
                            

        

    );





};
export default Cards;
